import React from 'react';
import { Icon } from '@chakra-ui/react';

const GeneralLabelsDocument: React.FC<React.PropsWithChildren<unknown>> = (
  props,
) => (
  <Icon viewBox="0 0 50 50" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37.28 16h-7a.29.29 0 01-.3-.3v-7a.3.3 0 01.51-.21l7 7a.3.3 0 01-.21.51z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M37.7 18h-9.4a.291.291 0 01-.3-.3V8.3a.29.29 0 00-.3-.3H12.3a.29.29 0 00-.3.3v33.4a.29.29 0 00.3.3h25.4a.29.29 0 00.3-.3V18.3a.29.29 0 00-.3-.3z"
      clipRule="evenodd"
    ></path>
  </Icon>
);

export default GeneralLabelsDocument;
